/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tl_Empty_Dates_BodyInputs */

const en_tl_empty_dates_body = /** @type {(inputs: Tl_Empty_Dates_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drag items from Unscheduled onto the timeline, or press Enter on a row to set dates. Planning by release? Show the milestones.`)
};

const de_tl_empty_dates_body = /** @type {(inputs: Tl_Empty_Dates_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zieh Vorgänge aus Ohne Termin auf die Zeitleiste oder drücke Enter in einer Zeile, um Termine zu setzen. Planung nach Release? Zeig die Meilensteine.`)
};

/**
* | output |
* | --- |
* | "Drag items from Unscheduled onto the timeline, or press Enter on a row to set dates. Planning by release? Show the milestones." |
*
* @param {Tl_Empty_Dates_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tl_empty_dates_body = /** @type {((inputs?: Tl_Empty_Dates_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tl_Empty_Dates_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_tl_empty_dates_body(inputs)
	return en_tl_empty_dates_body(inputs)
});